/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetCompanyStoriesLatestResponse,
    GetCompanyStoriesLatestResponseFromJSON,
    GetCompanyStoriesLatestResponseToJSON,
    GetNewArrivalStoriesResponse,
    GetNewArrivalStoriesResponseFromJSON,
    GetNewArrivalStoriesResponseToJSON,
    GetPickUpStoryListResponse,
    GetPickUpStoryListResponseFromJSON,
    GetPickUpStoryListResponseToJSON,
} from '../models';

export interface GetCompanyStoriesLatestRequest {
    companyId: number;
    limit?: number;
}

/**
 * 
 */
export class StoryApi extends runtime.BaseAPI {

    /**
     * * `200` - 指定した企業の公開されているStory一覧を取得する 
     * Storyのリストを取得する
     */
    async getCompanyStoriesLatestRaw(requestParameters: GetCompanyStoriesLatestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetCompanyStoriesLatestResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getCompanyStoriesLatest.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/story/ajax/company/{company_id}/stories/latest`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyStoriesLatestResponseFromJSON(jsonValue));
    }

    /**
     * * `200` - 指定した企業の公開されているStory一覧を取得する 
     * Storyのリストを取得する
     */
    async getCompanyStoriesLatest(requestParameters: GetCompanyStoriesLatestRequest, initOverrides?: RequestInit): Promise<GetCompanyStoriesLatestResponse> {
        const response = await this.getCompanyStoriesLatestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新着ストーリー一覧を取得する
     * Get New Arrival Stories
     */
    async getNewArrivalStoriesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetNewArrivalStoriesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/story_index.php`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNewArrivalStoriesResponseFromJSON(jsonValue));
    }

    /**
     * 新着ストーリー一覧を取得する
     * Get New Arrival Stories
     */
    async getNewArrivalStories(initOverrides?: RequestInit): Promise<GetNewArrivalStoriesResponse> {
        const response = await this.getNewArrivalStoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * * `200` - 現在設定されているPickUpコンテンツを取得する 
     * PickUpコンテンツ取得
     */
    async getPickUpStoryListRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPickUpStoryListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/story/ajax/posts/pickups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPickUpStoryListResponseFromJSON(jsonValue));
    }

    /**
     * * `200` - 現在設定されているPickUpコンテンツを取得する 
     * PickUpコンテンツ取得
     */
    async getPickUpStoryList(initOverrides?: RequestInit): Promise<GetPickUpStoryListResponse> {
        const response = await this.getPickUpStoryListRaw(initOverrides);
        return await response.value();
    }

}
